import { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import ticketusClient from '@/_http/axiosTicketusClient';
import { loggedIn$ } from '@/account/subs';
import { activeMark } from '@/mytickets/active/subs';
import { ticketusActiveLoaded } from '@/mytickets/active/handlers';

function ActiveTicketsLoader() {
    const { subscribe } = useReframe();
    const mark = subscribe(activeMark);
    const loggedIn = subscribe(loggedIn$);

    useEffect(() => {
        if (loggedIn) {
            ticketusClient.get('tickets/active').then(json => dispatch(ticketusActiveLoaded(json)));
        }
    }, [loggedIn, mark]);
    return null;
}

export default ActiveTicketsLoader;
